import React from 'react';
import Aboutimg01 from '../../../assets/images/about/check-icon-.svg';
import Aboutimg02 from '../../../assets/images/about/about-five.jpg';

const Aboutsec = () => {
    return (
        <>
            <div className="about-section-five">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-info-five">
                                <div className="heading-box">
                                    <span
                                        className="sub-title-two animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        About Us
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        We take any challenge of the digital world to create your
                                        corporate shape.
                                    </h2>
                                </div>
                                <p
                                    className="lead animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    At uniqo, we are a renowned global consulting firm committed to
                                    collaborating with business and societal leaders in overcoming their
                                    most critical challenges and seizing their greatest opportunities.{" "}
                                </p>
                                <ul
                                    className="about-list-five animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="600ms"
                                >
                                    <li>
                                        <span>
                                            <img src={Aboutimg01} alt="icon" />
                                        </span>
                                        <p>Growth Method Analysis</p>
                                    </li>
                                    <li>
                                        <span>
                                            <img src={Aboutimg01} alt="icon" />
                                        </span>
                                        <p>Project Management consultation</p>
                                    </li>
                                    <li>
                                        <span>
                                            <img src={Aboutimg01} alt="icon" />
                                        </span>
                                        <p>Team Building Leadership</p>
                                    </li>
                                    <li>
                                        <span>
                                            <img src={Aboutimg01} alt="icon" />
                                        </span>
                                        <p>Assessment Report Analysis</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="about-image-five animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <img src={Aboutimg02} alt="about-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Aboutsec;
